<template>
  <div class="pb-3" >
    <va-card :title="$t(`clients.cards.${titleCard}`)">
      <ValidationObserver v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(submit)">
          <div class="row">
            <div class="flex md12">
              <ValidationProvider rules="required" name="Primeiro Nome" v-slot="{ errors }">
                <va-input
                  v-model="client.firstName"
                  :label="$t('clients.forms.firstNameLabel')"
                  :placeholder="$t('clients.forms.firstNamePlaceholder')"
                  :success="errors.length == 0 && client.firstName.length > 0"
                  :error="errors.length > 0"
                  :error-messages="errors"
                />
              </ValidationProvider>
              <ValidationProvider rules="required" name="Ultimo Nome" v-slot="{ errors }">
                <va-input
                  v-model="client.lastName"
                  :label="$t('clients.forms.lastNameLabel')"
                  :placeholder="$t('clients.forms.lastNamePlaceholder')"
                  :success="errors.length == 0 && client.lastName.length > 0"
                  :error="errors.length > 0"
                  :error-messages="errors"
                />
              </ValidationProvider>
              <ValidationProvider rules="required|email" name="Email" v-slot="{ errors }">
                <va-input
                  type='email'
                  v-model="client.email"
                  :label="$t('clients.forms.emailLabel')"
                  :placeholder="$t('clients.forms.emailPlaceholder')"
                  :success="errors.length == 0 && client.email.length > 0"
                  :error="errors.length > 0"
                  :error-messages="errors"
                />
              </ValidationProvider>
              <ValidationProvider :rules="client.password.length > 0 ? 'min:6|required|confirmed:client.confirmPassword' : ''" name="Senha" v-slot="{ errors }">
                <va-input
                  v-model="client.password"
                  type="password"
                  :label="$t('clients.forms.passwordLabel')"
                  :placeholder="$t('clients.forms.passwordPlaceholder')"
                  :success="errors.length == 0 && client.password.length > 0"
                  :error="errors.length > 0"
                  :error-messages="errors"
                />
              </ValidationProvider>
              <ValidationProvider :vid="client.password.length > 0 ? 'client.confirmPassword' : ''" name="Confirme a Senha">
                <va-input
                  v-model="client.confirmPassword"
                  type="password"
                  :label="$t('clients.forms.confirmPasswordLabel')"
                  :placeholder="$t('clients.forms.confirmPasswordPlaceholder')"
                  :success="client.confirmPassword.length > 0"
                />
              </ValidationProvider>
              <ValidationProvider rules="required" name="Plano" v-slot="{ errors }">
                <va-select
                  v-model="plan"
                  text-by='name'
                  key-by='id'
                  :options="plans"
                  clearable="false"
                  noOptionsText="Sem Items"
                  :label="$t('clients.forms.plansLabel')"
                  :placeholder="$t('clients.forms.plansPlaceholder')"
                  :success="errors.length == 0 && plan != ''"
                  :error="errors.length > 0"
                ></va-select>
                <ErrorMessages
                  :errors="errors"
                />
              </ValidationProvider>
              <ValidationProvider rules="required" name="Clubes" v-slot="{ errors }">
                <va-select
                  v-model="club"
                  text-by='name'
                  key-by='id'
                  :options="clubs"
                  clearable="false"
                  noOptionsText="Sem Items"
                  :label="$t('clients.forms.clubsLabel')"
                  :placeholder="$t('clients.forms.clubsPlaceholder')"
                  :success="errors.length == 0 && club != ''"
                  :error="errors.length > 0"
                ></va-select>
                <ErrorMessages
                  :errors="errors"
                />
              </ValidationProvider>
              <div class="d-flex mt-3">
                <va-button
                  type="submit"
                  :disabled="buttonSubmitDisabled"
                  color="success"
                  class="my-0">
                  {{ textSubmit }}
                </va-button>
                <va-button
                  type="button"
                  class="my-0"
                  color="danger"
                  @click="cancel">
                  {{ $t("forms.cancel") }}
                </va-button>
              </div>
            </div>
          </div>
        </form>
      </ValidationObserver>
    </va-card>
  </div>
</template>

<script>
import ErrorMessages from '../utils/ErrorMessages'
import gql from 'graphql-tag'
export default {
  name: 'ClientAddUpdate',
  components: { ErrorMessages },
  props: {
    page: {
      type: Number,
      required: true,
    },
    titleCard: {
      type: String,
      required: true,
    },
    updateData: {
      required: true,
    },
  },
  data () {
    return {
      client: {
        firstName: '',
        lastName: '',
        email: '',
        password: '',
        confirmPassword: '',
        plan_id: '',
        club_id: '',
      },
      clubs: [],
      plans: [],
      club: '',
      plan: '',
      buttonSubmitDisabled: false,
      textSubmit: this.$t('forms.submit'),
    }
  },
  apollo: {
    clubs: gql`
      query MyQuery {
        clubs: club {
          id
          name
        }
      }
      `,
    plans: gql`
      query MyQuery {
        plans: plan {
          id
          name
        }
      }
      `,
  },
  mounted () {
    this.client.fistName = ''
    this.client.lastName = ''
    this.client.email = ''
    this.client.password = ''
    this.client.confirmPassword = ''
    this.client.club_id = ''
    this.client.club = ''
    this.client.plan_id = ''
    this.client.plan = ''
    if (this.updateData !== null) {
      this.client_get(this.updateData)
    }
  },
  watch: {
    updateData (value) {
      if (this.updateData !== null) {
        this.client_get(this.updateData)
      } else {
        this.client.fistName = ''
        this.client.lastName = ''
        this.client.email = ''
        this.client.password = ''
        this.client.confirmPassword = ''
        this.client.club_id = ''
        this.client.club = ''
        this.client.plan_id = ''
        this.client.plan = ''
      }
    },
    club (value) {
      this.client.club_id = value.id
    },
    plan (value) {
      this.client.plan_id = value.id
    },
  },
  methods: {
    submit () {
      if (this.updateData != null) {
        this.onUpdate()
      } else {
        this.onSubmit()
      }
    },
    cancel () {
      this.$emit('showAdd', false)
    },
    client_get (data) {
      Object.keys(data).forEach((value, key) => {
        if (value !== 'club' && value !== 'plan' && value !== 'role' && value !== '__typename') {
          this.client[value] = data[value]
        } else if (value === 'club') {
          this.club = data.club
          this.client.club_id = data.club.id
        } else if (value === 'plan') {
          this.plan = data.plan
          this.client.plan_id = data.plan.id
        }
      })
    },
    onSubmit () {
      this.buttonSubmitDisabled = true
      this.textSubmit = this.$t('forms.submitting')
      const self = this
      this.$axios.post(
        '/api/client/add',
        this.client,
      )
        .then(response => {
          self.buttonSubmitDisabled = false
          self.textSubmit = self.$t('forms.submit')
          self.client.fistName = ''
          self.client.lastName = ''
          // self.client.phone = ''
          self.client.club_id = ''
          self.client.club = ''
          self.client.plan_id = ''
          self.client.plan = ''
          self.$emit('showAdd', false)
          self.$emit('showMore', self.page)
          self.showToast(
            self.$t('toasts.successCreate'),
            {
              icon: 'fa-check',
              position: 'top-right',
              duration: 1000,
              fullWidth: false,
            },
          )
        })
        .catch(e => {
          self.buttonSubmitDisabled = false
          self.textSubmit = self.$t('forms.submit')
          self.client.fistName = ''
          self.client.lastName = ''
          self.client.email = ''
          self.client.password = ''
          self.client.confirmPassword = ''
          self.client.club_id = ''
          self.client.club = ''
          self.client.plan_id = ''
          self.client.plan = ''
          self.$emit('showAdd', false)
          self.showToast(
            self.$t('toasts.errorCreate'),
            {
              icon: 'fa-check',
              position: 'top-right',
              duration: 1000,
              fullWidth: false,
            },
          )
        })
    },
    onUpdate () {
      this.buttonSubmitDisabled = true
      this.textSubmit = this.$t('forms.submitting')
      // eslint-disable-next-line camelcase
      const {
        firstName,
        lastName,
        email,
        password,
        confirmPassword,
        // eslint-disable-next-line camelcase
        club_id,
        // eslint-disable-next-line camelcase
        plan_id,
        id,
      } = this.client
      const data = {
        firstName,
        lastName,
        email,
        // eslint-disable-next-line camelcase
        club_id,
        // eslint-disa.planble-next-line camelcase
        plan_id,
        id,
      }
      if (password.length > 6 && confirmPassword.length > 0 && password === confirmPassword) {
        data.password = password
        data.confirmPassword = confirmPassword
      }
      const self = this
      this.$axios.put(
        `/api/client/${this.client.id}`,
        data,
      )
        .then(response => {
          self.buttonSubmitDisabled = false
          self.textSubmit = self.$t('forms.submit')
          self.client.firstName = ''
          self.client.email = ''
          self.client.password = ''
          self.client.confirmPassword = ''
          self.$emit('showAdd', false)
          self.$emit('showMore', self.page)
          self.showToast(
            self.$t('toasts.successUpdate'),
            {
              icon: 'fa-check',
              position: 'top-right',
              duration: 1000,
              fullWidth: false,
            },
          )
        })
        .catch(e => {
          self.buttonSubmitDisabled = false
          self.textSubmit = self.$t('forms.submit')
          self.client.firstName = ''
          self.client.email = ''
          self.client.password = ''
          self.client.confirmPassword = ''
          self.$emit('showAdd', false)
          self.showToast(
            self.$t('toasts.errorUpdate'),
            {
              icon: 'fa-check',
              position: 'top-right',
              duration: 1000,
              fullWidth: false,
            },
          )
        })
    },
  },
}
</script>

<style lang="scss">
</style>
